// extracted by mini-css-extract-plugin
export default {"pageWrapper":"Layout_pageWrapper__Rcplx","pageBody":"Layout_pageBody__59pZp"};